import { render, staticRenderFns } from "./CreateReportGroupModal.vue?vue&type=template&id=28996e3c"
import script from "./CreateReportGroupModal.vue?vue&type=script&lang=ts"
export * from "./CreateReportGroupModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports